import styled from "styled-components";

interface BannerStyleProps {
  backgroundColor?: string;
}
export const BannerStyle = styled.div<BannerStyleProps>`
  background: ${(props) => props.backgroundColor};
  padding: 10px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  margin-bottom: 40px;
`;

export const ConsentStyles = styled.div`
  font-size: 14px;
  font-weight: 400;
`;
